import {Component, OnInit} from '@angular/core';
import { NgForm } from '@angular/forms';
import {TokenManagerService} from '../shared/services/token-login.service';
import {LoginModel} from './login.model';
import {Router} from '@angular/router';


@Component({
  selector: 'app-login',
  providers: [TokenManagerService],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.less']
})
export class LoginComponent implements OnInit {
  userModel = new LoginModel();
  loginInfo = false;
  loginResponse = '';
  rememberMe: boolean;
  focus: boolean;
  focusPass: boolean;

  constructor(private tokenManagerService: TokenManagerService, private _router: Router) {
    this.tokenManagerService = tokenManagerService;
  }

  submitLogin(form: NgForm, isValid: boolean) {

    console.log(this.rememberMe);
    if ( isValid ) {
      this.tokenManagerService.login(this.userModel, this.rememberMe).subscribe(
        (response) => {
          console.log(response);
          this._router.navigateByUrl('Home');
          console.log(sessionStorage.getItem('currentUser'));
        },
        (error) => {
          console.log(error);
          this.loginInfo = true;
          this.loginResponse = error;
        }
      );
    }
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/authorization/login.component.ts